import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import styles from '../styles/SalesChart.module.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const data = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
  datasets: [
    {
      label: 'Sales',
      data: [1200, 1900, 1700, 2200, 2000, 2500, 2300],
      borderColor: '#6366f1',
      backgroundColor: 'rgba(99,102,241,0.1)',
      tension: 0.4,
      fill: true,
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: { display: false },
    title: { display: true, text: 'Sales Overview', color: '#3730a3', font: { size: 18 } },
  },
  scales: {
    x: { grid: { display: false }, ticks: { color: '#3730a3' } },
    y: { grid: { color: '#e0e7ff' }, ticks: { color: '#3730a3' } },
  },
};

const SalesChart = () => (
  <div className={styles.chartContainer}>
    <Line data={data} options={options} />
  </div>
);

export default SalesChart; 